import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DailyTripType } from '../../../models/trips/dailyTripType';
import { DailyTripService } from '../../../services/daily-trip.service';

@Component({
  selector: 'ztsi-daily-trip-type-select',
  templateUrl: './ztsi-daily-trip-type-select.component.html',
  styleUrls: [],
  providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => ZtsiDailyTripTypeComponent),
			multi: true
		}
	]
})
export class ZtsiDailyTripTypeComponent implements ControlValueAccessor {
	types: DailyTripType[] = [];

	@Input('value') _value: number;
	@Input() isDisabled: boolean = false;

	onChange: any = () => { };
	onTouched: any = () => { };

	get value() {
		return this._value;
	}

	set value(val) {
		this._value = val;
		this.onChange(val);
		this.onTouched();
	}

	constructor(
		private _dailyTripService: DailyTripService
	) { }

	writeValue(value): void {
		if (value !== undefined) {
			this._value = value;
		}
	}

	registerOnChange(fn: any): void {
		this.onChange = fn;
	}

	registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}

	ngOnInit() {
		this._dailyTripService.getDailyTripTypes().subscribe(response => {
			if (response.length != undefined && response.length > 0) {
				this.types = response;
			}
			else {
				console.log('Unable to load daily trip type selection.');
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/components/shared/ztsi-daily-trip-type-select/ztsi-daily-trip-type-select.component.ts